import React from 'react';
import { CHAT_STORE, ChatStore, RemetenteMensagem, PagedRequest } from '../../Store/Chat';
import {
  Card,
  CardTitle,
  CardActions,
  Button,
  CardContent,
  Modal,
  InputFile,
  Checkbox,
  Textarea,
  TextButton,
  TabComponent,
  TabPanel,
  Input,
  TutorialButtonAndBackButton
} from '../../Components';
import styled from 'styled-components';
import { inject, observer } from 'mobx-react';
import { RouteComponentProps } from 'react-router';
import { format } from 'date-fns';
import Chat from '../../Components/Chat';
import { HelpButton } from '../Shared/HelpButton';
import { MonografiaStore, MONOGRAFIA_STORE } from '../../Store';
import Tutorial_Professor from "../../Utils/Tutorial/Manual_do_portal_do_TCC_Professor.pdf";
import PageSubTitle from "../../Components/PageSubTitle";

interface IProps extends RouteComponentProps<{ id: string }> {
  [CHAT_STORE]: ChatStore;
  [MONOGRAFIA_STORE]: MonografiaStore;
}

interface IState {
  isModalOpen: boolean;
}

const StyledCardActions = styled(CardActions) <any>`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-end;
  padding-top: 20px;
`
const StyledMesageInput = styled(Textarea) <any>`
  flex-grow: 1;
`;

const StyledContainer = styled.div`
  padding: 10px 5px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const StyledButtons = styled.div`
  display: flex;
`;

const StyledText = styled.p`
  margin: 0;
  font-size: 20px;
`;

const StlyedHelpButton = styled(HelpButton)`
  margin-left: 5px;
  margin-top: 5px;
`;

const StlyedHelpButtonActions = styled(HelpButton)`
  margin-right: 15px;
`;

@inject(CHAT_STORE, MONOGRAFIA_STORE)
@observer
export default class ChatPage extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      isModalOpen: false
    }
  }

  sendMessage = async (id: number) => {
    const store = this.props[CHAT_STORE];

    await store.sendMensagem(['professor', id]).then(() => {
      store.getMensagens(['professor', id], true, new PagedRequest({ search: '', page: 1, pageSize: 10 }))
    });
  }

  sendEncontroPresencial = async (id: number) => {
    const store = this.props[CHAT_STORE];

    await store.sendRegistroDeEncontroPresencial(id).then(() => {
      store.getMensagens(['professor', id], true, new PagedRequest({ search: '', page: 1, pageSize: 10 }))
    });
  }

  handleChange = (dynamicArguments: ['anexo', File] | ['texto', string] | ['aluno', number]) => {
    const store = this.props[CHAT_STORE];

    store.updateMessageAttribute(dynamicArguments[0], dynamicArguments[1]);
  }

  handleChangeEncontroPresencial = (
    dynamicArguments: ['tituloDoEncontro', string]
      | ['resumo', string]
      | ['aluno', string]
      | ['orientacoes', string]
      | ['dataDoEncontro', Date]
  ) => {
    const store = this.props[CHAT_STORE];
    store.updateAttributeEncontroPresencial(dynamicArguments[0], dynamicArguments[1]);
  }

  componentDidMount() {
    const chatStore = this.props[CHAT_STORE];

    chatStore.getMensagens(['professor', parseInt(this.props.match.params.id)]);
    chatStore.getOrientacoes(true, new PagedRequest({
      search: this.props.match.params.id,
      page: 1,
      pageSize: 1
    }));

  }

  getMoreMessages = (id: number) => {
    const store = this.props[CHAT_STORE];

    store.getMensagens(['professor', id]);
  }

  doDownload = (id: string) => {
    const store = this.props[CHAT_STORE];

    store.getAnexo(id);
  }

  onResumeClick = () => {
    window.open(Tutorial_Professor);
  }

  render() {
    const {
      [CHAT_STORE]: chatStore
    } = { ...this.props };
    const {
      novaMensagem,
      encontroPresencial,
      mensagens,
      apiStates,
      orientacoesList
    } = chatStore;
    const { history } = this.props;
    const alunoId = parseInt(this.props.match.params.id);
    const orientacao = orientacoesList.find(o => o.aluno.id === parseInt(this.props.match.params.id));

    return (
      <>
        <PageSubTitle subTitle={'Diário de Orientações'} />
        <TutorialButtonAndBackButton
          openTutorial={this.onResumeClick}
          voltar={() => history.push('/professor')}
        />
        <Card>
          <CardTitle>
            <StyledText>Orientações para {(orientacao && orientacao.aluno.nome) || 'aluno'}</StyledText>
            <StlyedHelpButton>
              <div>
                <p>
                  Registre nesse diário todas as orientações dadas durante o período de orientação. Responda também às perguntas dos Orientandos.
                </p>
                <p>
                  Envie aqui exclusivamente mensagens de orientação, breves e científicas. Pode ser anexado documento, como, por exemplo, trechos do TCC com anotações do Orientador.
                </p>
                <p>
                  Não é um "chat" síncrono. É um registro oficial, "pro memoria", de suas orientações específicas ao TCC do Aluno.
                </p>
                <p>
                  Pode ser usado também para responder às solicitações específicas de orientação, postadas pelo Aluno.
                </p>
              </div>
            </StlyedHelpButton>
          </CardTitle>
          <CardContent>
            <Chat
              usuario={RemetenteMensagem.professor}
              mensagens={mensagens}
              carregando={apiStates.getMensagensState}
              carregarMais={() => { this.getMoreMessages(alunoId); }}
              doDownload={this.doDownload}
              orientacao={orientacao}
            />
          </CardContent>
          <StyledCardActions>
            <StyledContainer>
              <StyledMesageInput
                value={novaMensagem.texto || ''}
                type='text'
                label='Mensagem'
                onChange={(e: any) => this.handleChange(['texto', e.target.value])}
              />
              <Checkbox
                label='Marque aqui, se deseja que o Aluno seja notificado dessa mensagem por e-mail'
              />
            </StyledContainer>
            <StyledButtons>
              <TextButton onClick={() => this.setState({ isModalOpen: true })}>
                <img width="20px" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAA00lEQVRIie2VTQrCMBCFP1y48ga16sYTiDfQK6pXkOLGulBPY90LWleKUBd9wVot2DSCSB+EwEzyvWHID/yA2kAAxBoLoO8SfgCS3DgAnguDQMBQQA9YKTZ3YRALlq3WV+zowsC05NP4ixrfNitjYKXaoDb4M4OrZvOSXlwUkL2lW55f1PWbNaV10+Ym0AE2wFlwX/FE66y0F2BQkB8qv7M1mAmwLMiHyk9sDXo8/oSQtOKWZgM/kbbPWmNB8t+mgY+qwI26wBSISI9nRNqWSpU70R2qYEYBWs09wgAAAABJRU5ErkJggg==" />
              </TextButton>
              <Button onClick={() => this.sendMessage(alunoId)}>Enviar</Button>
            </StyledButtons>
          </StyledCardActions>
        </Card>
        <Modal
          isVisible={this.state.isModalOpen}
          outterClick={() => this.setState({ isModalOpen: false })}
          size={'small'}
        >
          <TabComponent activeChild={'Arquivo'}>
            <TabPanel titulo={"Arquivo"}>
              <Card>
                <CardContent
                  style={{ marginTop: '10px', marginBottom: '-10px' }}
                >
                  <InputFile
                    label={'Anexe aqui seu arquivo'}
                    width={'100%'}
                    accept="application/pdf"
                    onChange={(e) => this.handleChange(["anexo", e.target.files[0]])}
                  />
                </CardContent>
                <StyledCardActions>
                  <StyledMesageInput
                    value={novaMensagem.texto || ''}
                    type='text'
                    label='Mensagem'
                    onChange={(e: any) => this.handleChange(["texto", e.target.value])}
                  ></StyledMesageInput>
                  <StyledButtons>
                    <Button onClick={() => {
                      this.sendMessage(alunoId);
                      this.setState({ isModalOpen: false });
                    }}>Enviar</Button>
                  </StyledButtons>
                </StyledCardActions>
              </Card>
            </TabPanel>
            <TabPanel titulo={"Registro de encontro presencial"}>
              <Card>
                <CardContent>
                  <Input
                    label={'Local do encontro'}
                    style={{ width: '100%' }}
                    type={'text'}
                    value={encontroPresencial.tituloDoEncontro}
                    onChange={(e) => this.handleChangeEncontroPresencial(['tituloDoEncontro', e.target.value])}
                  />
                  <Input
                    label={'Resumo'}
                    style={{ width: '100%' }}
                    type={'text'}
                    value={encontroPresencial.resumo}
                    onChange={(e) => this.handleChangeEncontroPresencial(['resumo', e.target.value])}
                  />
                  <Input
                    label={'Data do encontro'}
                    style={{ width: '100%' }}
                    type={'date'}
                    value={encontroPresencial.dataDoEncontro && format(encontroPresencial.dataDoEncontro, 'YYYY-MM-DD')}
                    onChange={(e) => this.handleChangeEncontroPresencial(['dataDoEncontro', new Date(e.target.value + ' GMT-3')])}
                  />
                  <Input
                    label={'Orientações'}
                    style={{ width: '100%' }}
                    type={'text'}
                    value={encontroPresencial.orientacoes}
                    onChange={(e) => this.handleChangeEncontroPresencial(['orientacoes', e.target.value])}
                  />

                </CardContent>

                <StyledCardActions>
                  <StlyedHelpButtonActions>
                    <div>
                      <p>
                        Registre aqui os encontros presencias com os alunos "pro memoria".
                      </p>
                    </div>
                  </StlyedHelpButtonActions>
                  <Button onClick={() => {
                    this.sendEncontroPresencial(alunoId);
                    this.setState({ isModalOpen: false });
                  }}>Enviar</Button>
                </StyledCardActions>
              </Card>
            </TabPanel>
          </TabComponent>
        </Modal>
      </>
    )
  }
}